import { createSlice } from "@reduxjs/toolkit";

const initialExpirationState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  dashboardData: {
    total_expired: 0,
    total_follow_up: 0,
    total_dismantle: 0,
    total_perpanjang: 0
  },
  meta: {total : 0},
  links: null,
  lastError: null,
  expirationForEdit: undefined,
  expirationForExport: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const expirationSlice = createSlice({
  name: "expiration",
  initialState: initialExpirationState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		expirationFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		expirationDashboardFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      // console.log(entities);
      state.dashboardData = entities;
    },
		expirationExportFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.expirationForExport = entities;
      state.totalCount = totalCount;
    },
    expirationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.expiration.push(action.payload.expiration);
    },
    expirationDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.expiration.filter(el => el.expiration_id !== action.payload.id);
    },
    getExpiration: (state, action) => {
      state.actionsLoading = false;
      state.expirationForEdit = action.payload.expirationForEdit;
      state.error = null;
    },
    getExportExpiration: (state, action) => {
      state.actionsLoading = false;
      if(action.payload.expirationForExport === undefined) {
        state.expirationForExport = [];
      }else{
        state.expirationForExport.push(action.payload.expirationForExport);
      }
      state.error = null;
    },
    // updateProduct
    expirationUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.expiration = state.entities.expiration.map(entity => {
        if (entity.expiration_id === action.payload.expiration.expiration_id) {
          return action.payload.expiration;
        }
        return entity;
      });
    },
  },
});
